const linkLandingPagesValidationDE = {
    "add": {
        "title": {
            "required": "Titel ist erforderlich",
            "length": "Titel darf nicht länger als 32 Zeichen sein"
        },
        "short_description": {
            "length": "Beschreibung darf nicht länger als 80 Zeichen sein."
        },
        "back_url": {
            "required": "Back-URL ist erforderlich",
            "length": "Back-URL darf nicht länger als 10 Zeichen sein",
            "unique": "Oops! Diese Back-URL ist bereits mit einer anderen Zielseite verknüpft. Bitte versuchen Sie eine andere Back-URL.",
            "available": "Back-URL ist verfügbar",
            "invalid": "Back-URL ist ungültig"
        },
        "logo": {
            "required": "Logo ist erforderlich",
            "dimensions": "Logo muss mindestens 500 X 500 px groß sein und ein Bildverhältnis von 1:1 haben, JPG/JPEG/PNG-Formate werden unterstützt.",
            "choose": "Bitte wählen Sie ein Bild",
            "file": "Bitte laden Sie JPG- oder PNG-Formate hoch, minimale Auflösung 500 X 500 px und Bildverhältnis 1:1. Maximalgröße 2MB"
        },
        "background_image": {
            "dimensions": "Hintergrundbild muss mindestens 1000 X 1000 px groß sein und ein Bildverhältnis von 1:1 haben, JPG/JPEG/PNG-Formate werden unterstützt.",
            "choose": "Bitte wählen Sie ein Bild",
            "file": "Bitte laden Sie JPG- oder PNG-Formate hoch, minimale Auflösung 1000 X 1000 px und Bildverhältnis 1:1. Maximalgröße 5MB"
        },
        "social_link_destination_url_facebook": {
            "required": "Ziel-URL ist erforderlich",
            "regexp": "Ungültige URL",
            "invalid": "Ungültige Facebook-URL"
        },
        "social_link_destination_url_instagram": {
            "required": "Ziel-URL ist erforderlich",
            "regexp": "Ungültige URL",
            "invalid": "Ungültige Instagram-URL"
        },
        "social_link_destination_url_twitter": {
            "required": "Ziel-URL ist erforderlich",
            "regexp": "Ungültige URL",
            "invalid": "Ungültige Twitter-URL"
        },
        "social_link_destination_url_youtube": {
            "required": "Ziel-URL ist erforderlich",
            "regexp": "Ungültige URL",
            "invalid": "Ungültige Youtube-URL"
        },
        "social_link_destination_url_tiktok": {
            "required": "Ziel-URL ist erforderlich",
            "regexp": "Ungültige URL",
            "invalid": "Ungültige TikTok-URL"
        },
        "social_link_destination_url_linkedin": {
            "required": "Ziel-URL ist erforderlich",
            "regexp": "Ungültige URL",
            "invalid": "Ungültige LinkedIn-URL"
        },
        "social_link_destination_url_other": {
            "regexp": "Ungültige URL"
        },
        "featured_link_title": {
            "required": "Beschriftung ist erforderlich",
            "length": "Beschriftung darf 100 Zeichen nicht überschreiten"
        },
        "featured_link_destination_url": {
            "required": "Ziel-URL ist erforderlich",
            "regexp": "Ungültige URL"
        }
    },
    "update": {
        "title": {
            "required": "Titel ist erforderlich",
            "length": "Titel darf nicht länger als 32 Zeichen sein"
        },
        "short_description": {
            "length": "Beschreibung darf nicht länger als 80 Zeichen sein."
        },
        "back_url": {
            "required": "Back-URL ist erforderlich",
            "length": "Back-URL darf nicht länger als 10 Zeichen sein",
            "unique": "Oops! Diese Back-URL ist bereits mit einer anderen Zielseite verknüpft. Bitte versuchen Sie eine andere Back-URL.",
            "available": "Back-URL ist verfügbar",
            "invalid": "Back-URL ist ungültig"
        },
        "logo": {
            "required": "Logo ist erforderlich",
            "dimensions": "Logo muss mindestens 500 X 500 px groß sein und ein Bildverhältnis von 1:1 haben, JPG/JPEG/PNG-Formate werden unterstützt.",
            "choose": "Bitte wählen Sie ein Bild",
            "file": "Bitte laden Sie JPG- oder PNG-Formate hoch, minimale Auflösung 500 X 500 px und Bildverhältnis 1:1. Maximalgröße 2MB"
        },
        "background_image": {
            "dimensions": "Hintergrundbild muss mindestens 1000 X 1000 px groß sein und ein Bildverhältnis von 1:1 haben, JPG/JPEG/PNG-Formate werden unterstützt.",
            "choose": "Bitte wählen Sie ein Bild",
            "file": "Bitte laden Sie JPG- oder PNG-Formate hoch, minimale Auflösung 1000 X 1000 px und Bildverhältnis 1:1. Maximalgröße 5MB"
        },
        "social_link_destination_url_facebook": {
            "required": "Ziel-URL ist erforderlich",
            "regexp": "Ungültige URL",
            "invalid": "Ungültige Facebook-URL"
        },
        "social_link_destination_url_instagram": {
            "required": "Ziel-URL ist erforderlich",
            "regexp": "Ungültige URL",
            "invalid": "Ungültige Instagram-URL"
        },
        "social_link_destination_url_twitter": {
            "required": "Ziel-URL ist erforderlich",
            "regexp": "Ungültige URL",
            "invalid": "Ungültige Twitter-URL"
        },
        "social_link_destination_url_youtube": {
            "required": "Ziel-URL ist erforderlich",
            "regexp": "Ungültige URL",
            "invalid": "Ungültige Youtube-URL"
        },
        "social_link_destination_url_tiktok": {
            "required": "Ziel-URL ist erforderlich",
            "regexp": "Ungültige URL",
            "invalid": "Ungültige TikTok-URL"
        },
        "social_link_destination_url_linkedin": {
            "required": "Ziel-URL ist erforderlich",
            "regexp": "Ungültige URL",
            "invalid": "Ungültige LinkedIn-URL"
        },
        "social_link_destination_url_other": {
            "regexp": "Ungültige URL"
        },
        "featured_link_title": {
            "required": "Beschriftung ist erforderlich",
            "length": "Beschriftung darf 100 Zeichen nicht überschreiten"
        },
        "featured_link_destination_url": {
            "required": "Ziel-URL ist erforderlich",
            "regexp": "Ungültige URL"
        }
    }
};

export default linkLandingPagesValidationDE;